import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { convertToEasternArabic } from "utils";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)

const resources = {
  en: {
    translation: {
      soon: "Comming Soon",
      fileTypeNotSupported: "Extenstion of {{fileName}} not supported",
      acceptanceNeeded: "Acceptance needed",
      search: "Search",
      startSearching: "Start searching",
      multipleWorkspaces: "Multiple Cases",
      companyTimezone: "Company timezone",
      seeMore: "See more",
      abstain: "Abstain",
      yes: "yes",
      no: "no",
      select: "Select",
      offline: "Offline",
      beforeMeeting: "Before the session",
      accept: "Accept",
      ago: "ago",
      update: "Update",
      join: "Join",
      required: "Required",
      due: "due",
      more: "More",
      signature: "Signature",
      availableShares: "Available shares",
      aprove: "Approve",
      approved: "Approved",
      started: "Started",
      ended: "Ended",
      invitationTo: "Invitation to",
      accepted: "Accepted",
      addParticipants: "Add participants",
      add: "Add",
      addSection: "Add section",
      addSubsection: "Add subsection",
      editSubsection: "Edit subsection",
      addFile: "Add file",
      editMore: "Edit more",
      saveNewDate: "Save new date",
      updateSubsection: "Update subsection",
      agenda: "Agenda",
      close: "Close",
      logout: "Logout",
      resentcode: "Resent code",
      invalidcode: "Invalid code",
      resetlinksuccess: "We sent email or sms with code to log in",
      loginsuccess: "Login successful",
      hello: "Welcome",
      members: "members",
      workspace: "Case",
      from: "from",
      meetingAddress: "Session address",
      previousDay: "previous day",
      nextDay: "next day",
      loadMore: "load more",
      delete: "Delete",
      editDescription: "Edit description",
      type: "Type",
      public: "Public",
      private: "Private",
      priority: "Priority",
      login: "Log in",
      reset: "Reset",
      edit: "Edit",
      end: "End",
      return: "Return",
      forgotPassword: "Forgot your password?",
      seeSummary: "See summary",
      seeVotingSummary: "See Decision Summary",
      seeSummaryAndSign: "See summary and sign",
      timestamp: "Timestamp",
      mention: "Mention",
      decision: "Decision",
      remove: "Remove",
      activate: "Activate",
      deactivate: "Deactivate",
      recentActivity: "Recent activity",
      resetPassword: "Reset password",
      password: "Password",
      save: "Save",
      draft: "Draft",
      pending: "Pending",
      seeDetails: "See details",
      cancel: "Cancel",
      email: "Email",
      phone: "Phone",
      origin: "Origin",
      wrong: "Wrong",
      replace: "Replace",
      files: "Files",
      reject: "Reject",
      rejectReason: "Reason for rejection",
      shares: "Shares",
      share_one: "Share",
      share_other: "Shares",
      vote: "Vote",
      vote_other: "Votes",
      share: "Share",
      voteWeight: "Vote weight",
      location: "Location",
      privateMeeting: "Private Session",
      newMeeting: "New Session",
      editMeeting: "Edit Session Detials",
      clearFilters: "Clear filters",
      createPoll: "New Decision",
      createTask: "New Order",
      assignTask: "Assign order",
      createMeeting: "Create session",
      updateMeeting: "Update session",
      localMeeting: "Local session",
      localTime: "Local time",
      createDraft: "Create draft",
      uploadDocument: "Upload document",
      upload: "Upload",
      onlyNumbers: "Only numbers",
      users: "Users",
      usersProfile: "Users Profile",
      usersFrom: "Users from",
      role: "Role",
      editProfile: "Edit profile",
      allRoles: "All roles",
      addAll: "add all",
      addNewUser: "Add new user",
      searchUser: "Start typing name",
      noResults: "No results",
      participant_one: "Participant",
      participant_other: "Participants",
      invited_users: "Invited Users",
      user_one: "User",
      user_other: "Users",
      guest_other: "Guests",
      guest_one: "Guest",
      fileError: "This file name already exist",
      today: "Today",
      yesterday: "Yesterday",
      older: "older",
      add_performers: "Add performer",
      add_presenters: "Add presenter",
      addPresenter: "Add presenter",
      performers: "performers",
      presenters: "{{numbers}} Presenters",
      duration: "Duration",
      invitiationTo: "Invitation to",
      details: "details",
      description: "Description",
      addDescription: "Add description",
      userNotActive: "This user is inactive now.",
      performingConditions: "Performing conditions",
      workspacePresencePlaceholder:
        "If you want to decline the invitation, please give a reason",
      workspacePrenanceValidation: "Reason is needed",
      invitationDeclined: "Invitation declined",
      invitationAccepted: "Invitation accepted",
      reviewer_other: "Reviewers",
      reviewer_one: "Reviewer",
      poolsAndVotings: "Decisions",
      activeTasks: "Orders",
      pageingInfo: "Showing {{from}} - {{to}} from {{total}}",
      viaEmail: "via email",
      viaSms: "via SMS",
      inactive: "Inactive",
      quorum: "Quorum",
      vote_weight: "Vote Weight",
      invitations: "Invitations",
      dueDate: "Due date",
      onlyUnread: "Only unread",
      currentLifecycle: "Arbitration Case Lifecycle",
      titleOfMotion: "Title of motion",
      permissionsChanged: "Your permissions changed",
      deactivateUserMessage:
        "Are you sure you want to deactivate ( {{name}} ) ?",
      deactivateUserMessageDescription:
        "Deactivating a user suspends share transfers, affecting their transferability. Prior to deactivation, adjust, modify, or remove shares. Manage them before proceeding.",
      waitingForResponse: "waiting for response",
      participants: "Participants",
      participant: "Participant",
      newMeetingRoles: {
        participants: "{{numbers}} Participants",
        guests: "{{numbers}} Guests",
        reviewers: "{{numbers}} Reviewers",
      },
      quorumTypes: {
        majority_number: "Majority of number in company",
        majority_shares: "Majority of shares in company",
        majority_number_company: "Majority of number in company",
        majority_shares_company: "Majority of shares in company",
        majority_mixed: "Majority of number and shares in company",
        cumulative_voting: "Cumulative voting",
        majority_number_workspace: "Majority of number in workspace",
        majority_shares_workspace: "Majority of shares in workspace",
      },
      taskPriority: {
        low: "Low",
        normal: "Normal",
        important: "High",
        critical: "Critical",
      },
      meetingOperation: {
        text: "Text",
        voting: "Voting",
        task: "Order",
        votingResults: "Voting Results",
        taskResults: "Order Results",
      },
      taskStatus: {
        to_do: "To do",
        in_progress: "In progress",
        rejected: "Rejected",
        done: "Done",
      },
      language: {
        button: "Language",
        hello: "Hello {{name}}",
        systemLanguage: "System language",
        english: "English",
        arabic: "Arabic",
      },
      activity: {
        recentActivity: "Recent activity",
        days: {
          today: "today, {{date}}",
          yesterday: "yesterday, {{date}}",
        },
      },
      textCreator: {
        placeholders: {
          title: "Enter text title",
          description: "Enter text description",
        },
      },
      filters: {
        allTasks: "All global tasks",
        allVotings: "All Decisions",
        allMeetings: "All session",
        assignedToMe: "Assigned to me",
        allWorkspaces: "All case groups",
        myWorkspaces: "My case groups",
        dueDate: {
          today: "Due today",
          tomorrow: "Due tomorrow",
          thisWeek: "Due this week",
          thisMonth: "Due this month",
          overdue: "Overdue",
        },
      },
      setPassword: {
        setNew: "Set new password",
        passwordSet: "New password set",
        submit: "Set new",
      },
      voting: {
        votingOwner: "Voting owner",
        sharesUsed: "Shares used",
        participants: "Participants",
        voteSecrecy: "Vote Secrecy",
        heedMyVote: "Heed my vote",
        quorumType: "Majority Calculation",
        givePower: "Give your power to {{name}}",
        requestVote: "Request {{name}} to vote",
        votingType: "Voting type",
        optionsToChoose: " Number of options to choose",
        optionsToWin: "Number of options to win",
        saveVoting: "Send Decision",
        voting: "Voting",
        addElement: "Add elements",
        users: "Users",
        addUser: "Add user",
        label: {
          dateStart: "Decision start date",
          dateEnd: "Decision end date",
          votingResult: "Decision result",
        },
        placeholders: {
          name: "Enter voting title",
          option: "Enter decision option",
          note: "The informations added in this field will be visible as a summary of the voting result",
        },
        votingRoles: {
          voting_owner: "Owner",
          voting_voter: "Voter",
          voting_commentator: "Commentator",
          voting_viewer: "Viewer",
          voting_eliminated: "Eliminated",
        },
        actionMessages: {
          created: "Voting created",
          updated: "Voting updated",
          deleted: "Voting deleted",
          statusUpdated: "Status updated",
          noteSaved: "Voting note saved",
          voteTransferred: "Vote transferred",
          remindNotificationSent: "Remind notification sent",
        },
      },
      profile: {
        title: "Profile",
        email: "E-mail",
        phone: "Phone",
        memberOf: "Member of",
        location: "Location",
      },
      rolesSelect: {
        general: "General",
        votings: "Decisions",
        meetings: "Sessions",
      },
      twoStepAuth: {
        title: "2 step authentication",
        info: "Enter verfication code. We sent it to",
      },
      companyForm: {
        contactInformations: "Contact informations",
        sharesTitle: "Shares",
      },
      roles: {
        secretary: "أمين السر",
        global_1733145008: "ممثل المنشأة",
        executive_mng: "مُحتكم",
        admin: "المشرف",
        board_director: "رئيس هيئة التحكيم",
        shareholder: "مُحكم",
        independent: "مُحتكم ضده/ا",
        executive: "وكيل طرف",
        guest: "خبير",
        meeting_owner: "رئيس هيئة التحكيم",
        meeting_admin: "أمين السر",
        meeting_secretary: "مُحكم",
        meeting_attendee: "محتكم",
        meeting_guest: "خبير",
        meeting_viewer: "مستمع",
        voting_owner: "أمين السر",
        voting_voter: "مصّوت",
        voting_commentator: "معلّق",
        voting_viewer: "مشاهد",
        manager: "Executive manager",
        member: "Member",
        chief: "Chief Executive Officer",
        boardOfDirectors: "Board Of Directors",
        executiveManagement: "Executive Management",
        auditor: "Auditor",
        regularGeneralAssembly: "Regular General Assembly",
        extraordinaryGeneralAssembly: "Extraordinary General Assembly",
        waiting_for_account: "Waiting for an account",
        meeting_organizer: "meeting_organizer",
        meeting_shareholder: "Shareholder",
        meeting_board_of_directors: "Board of Directors",
        meeting_executive_management: "Executive Management",
        meeting_independent_board_member: "Independent Board Member",
        meeting_executive_brd_mbr_com: "Executive Board Member with Committees",
        meeting_auditor: "Auditor",
        meeting_regular_general_assembly: "Regular General Assembly",
        meeting_extraordinary_general_assembly:
          "Extraordinary General Assembly",
        voting_eliminated: "Eliminated",
        some_custom_role_mm: "Some custom role MM",
      },
      notification: {
        remind: "Remind me in 10 min",
        meeting: {
          invitation: {
            inviting: "Inviting person: {{name}}",
            date: "Date: {{date}}",
            form: "Form: ",
          },
        },
      },

      meetingRoles: {
        secretary: "Secretary",
        organiser: "Organiser",
        guest: "Guest",
      },
      userTypes: {
        internal: "Internal",
        external: "External",
      },
      menu: {
        home: "Home",
        workspaces: "Cases",
        calendar: "Calendar",
        messages: "Messages",
        documents: "Documents",
        tasks: "Orders",
        votings: "Decisions",
        pollsAndVotings: "Decisions",
        styleguide: "Styleguide",
        minimize: "Minimize menu",
        settings: "Settings",
        adminDashboard: "Admin dashboard",
      },
      dashboards: {
        goodMorning: "Hi",
        quickActions: "Quick actions",
        pendingActions: "Pending actions",
        newRequests: "New requests",
        comingUpNext: "Coming up next",
        actionItems: "Action items",
        activityFromWorkspaces: "Activity from the case group",
        workspacesUpdates: "Case group updates",
        urgent: "Urgent order:",
      },
      registerForm: {
        fullName: "Full name",
        role: "Role",
        userType: "User type",
        addUser: "Add user",
        caseName: "Case Name",
      },
      loginWithNafath: "Nafath Login",
      somethingWentWrong:
        "To login though Nafath, you need to set your National Id in your profile first!",
      nationalId: "National ID",
      sendOtp: "Send",
      createMeetingForm: {
        choosePerformersFirst: "First add Performers, then Presenters",
        chooseVotingBefore: "Choose voting before session",
        chooseTaskBefore: "Choose order before session",
        resultsOfTask: "Results of order before session",
        resultOfVoting: "Result of voting before session",
        typeTaskName: "Type order name",
        typeVotingName: "Type voting name",
        subsectionDuration: "Subsection duration",
        updateSubsection: "Update subsection",
        addSelected: "Add selected",
        meetingDeleted: "session deleted",
        majorityOfShares: "Majority of shares",
        majorityOfNumber: "Majority of number",
        majorityOfNumberAndShares: "Majority of number and shares",
        meetingCreatorTitle: "session creator",
        titleRequired: "Title is required",
        enterTitle: "Enter session title",
        enterDescription: "Enter optional session description",
        enterMeetingAddress: "Enter session address",
        frequencyDaysRequired: "Select days for repeat",
        meetingCreated: "session created",
        meetingUpdated: "session draft updated",
        workspace: "Case Group",
        quorumTypes: {
          majority_number: "Majority of number in company",
          majority_shares: "Majority of shares in company",
          majority_number_company: "Majority of number in company",
          majority_shares_company: "Majority of shares in company",
          majority_mixed: "Majority of number and shares in company",
          cumulative_voting: "Cumulative voting",
          majority_number_workspace: "Majority of number in workspace",
          majority_shares_workspace: "Majority of shares in workspace",
        },
        enterTitlePlaceholder: "Enter title",
        sectionTitleRequired: "Section title is required",
        titleLengthErrorMax: "Title is too long. Max 100 characters",
        titleLengthErrorMin: "Title is too short. Min 1 characters",
        sectionDeleteConfirmation: "Are you sure you want to delete section?",
        deleteConfirmation: "Are you sure you want to delete {{entity}}?",
        updated: "Updated:",
        secondsAgo: "{{seconds}} seconds ago",
        minutesAgo: "{{seconds}} minutes ago",
        updateNow: "Update now",
        saveNow: "Save now",
        peopleInMeeting: "Session Members",
        guestModal: "Invite external member",
        guestModalAdditionalText:
          "You need to save session, until you will invite external member.",
        participantList: {
          removeUserModalTitle: "Remove Participants",
          removeUserModalHeader:
            "You're about to remove {{name}} from the session.",
          removeUserModalSectionText: "This user is currently attending:",
          removeUserModalSubsectionText: "This user is also participating in:",
          confirmationMessage:
            "If you remove the user, they will be removed from the agenda section(s) but will not be removed from any assigned orders or votes. You will need to remove them manually from the assigned events.",
          ok: "OK",
          cancel: "Cancel",
          genericConfirmationMessage:
            "Are you sure you want to remove {{name}} from session?",
        },
        selectCalculationMethod: "Select Method",
        type: "Session Holding place",
      },
      viewMeeting: {
        noAccessSection: "You don't have access to this section",
        agenda: {
          lastEdited: "Last edited by {{name}}",
        },
      },
      meetingTypes: {
        by_presence: "By presence",
        remote: "Remote",
      },
      meetingMessages: {
        remindMeIn: "Remind me in {{min}} min",
        startingInMinutes_one: "Starting in one minute",
        startingInMinutes: "Starting in",
        years: "years",
        months: "months",
        days: "days",
        minutes: "minutes",
        hours: "hours",
        sentToApprova: "Session sent to approval",
        startReview: "Started session review",
        approve: "Session approved",
        disapprove: "Session disapproved",
        acceptPresence: "Presence accepted",
        rejectPresence: "Presence rejected",
        successNextSection: "Next section",
        successPreviousSection: "Previous section",
        successSectionMeetingMinutes: "Session minutes saved",
        meetingPostponedAction: "Session postponed",
        sentForApproval: "Session sent for approval",
      },
      meetingAction: {
        approvalSend: "Send draft to approval",
        approval: "Approval",
        disapproval: "Disapproval",
        startReview: "Start review",
        resendInvitation: "Re-send invitation to {{name}}",
        resendInvitationSuccess: "Invitation has been resent ",
      },
      meetingLabels: {
        reason: "Reason",
        rejectReason: "Reject reason:",
        disapprovalTitle: "Disapprove Session: ",
        rejectInvitationTitle: "Reject Session invitation: ",
      },
      userRolesSettings: {
        protectedRoleError: "You can't delete protected role",
        assignedRoleError: "You can't delete role that is assigned to user",
        requiredPermissions: "Required permissions",
        rolesPageTitle: "Roles & Permissions",
        searchPlaceholder: "Start typing permission name",
        newRoleAdded: "New role added",
        roleName: "Role name",
        roleDeleted: "Role deleted",
        roleModalDelete: "Are you sure you want to delete role",
        roleNameMaxLength: "Max 50 characters",
        roleDescriptionModalTitle: "You are editing description for role",
        roleUpdated: "Role updated",
      },
      userEditForm: {
        sharesTitle: "Shares",
        totalShares: "Total number of users",
        sharesToBig: "Must be less or equal {{max}}",
        sharesToBigMore:
          "If you want to add more shares to this user first change the number of shares in another user accordingly",
        sharesToSmall: "Must be greater or equal 0",
        sharesInCompany: "Users in the company",
        quorumInNumber: "Quorum in number",
        contactInformations: "Contact informations",
        emailAddress: "E-mail address",
        phoneNumber: "Phone number",
        location: "Location",
        roleAndPower: "Role & power in meetings",
        save: "Save changes",
        _2fa: "2’nd Factor Authentication",
        workspaceMembership: "Membership in workspaces",
        showUserWorkspaces: "Show user cases",
        avatarDeleted: "Avatar deleted",
        votingWeight: "Voting weight",
        nationalId: "Saudi National Id",
      },
      createWorkspaceForm: {
        deleteConformation: "Are you sure you want to delete case group?",
        usersAdded: "Users invited to case group",
        nameRequired: "Name is required",
        enterName: "Enter case group name",
        description: "case group description (optional)",
        startTime: "Duration from",
        endTime: "to",
        createWorkspace: "Create case group",
        newWorkspace: "New case group",
        members: "{{numbers}} Members",
        addMember: "Add member",
        workspaceCreated: "case group created",
        workspaceUpdated: "case group updated",
        workspaceDeleted: "case group deleted",
        updateWorkspace: "Update case group",
        photoText: "case group photo",
        nameTooLong: "Name is too long. Max 50 characters",
        descriptionTooLong: "Description is too long. Max 2000 characters",
        endDateRequired: "End date is required",
        userDeleted: "User deleted",
        workspace: {
          named: "case group: {{name}}",
          unnamed: "Another case group",
        },
      },
      addGuest: {
        title: "Add Guest",
        submit: "Add Guest",
        addedGuestError: "Guest is aleady added",
        labels: {
          name: "Name",
          email: "E-mail address",
          phone: "Phone number",
          invitationText: "Invitation text",
        },
        placeholders: {
          name: "Enter name",
          email: "Enter e-mail address",
          phone: "Enter phone number",
          invitationText: "Enter invitation text",
        },
      },
      workspaces: {
        lifeCycle: "Arbitration Case Lifecycle",
        seeArchive: "See archive",
        workspace: "case group",
        createWorkspace: "Create case group",
        memberOf: "You are currently a member of {{count}} case groups",
        meetings: "Sessions",
        addMeeting: "Add Session",
      },
      notifications: {
        title: "Notifications",
        noData: "You have no new notifications",
        markAllRead: "mark everything as read",
        markAsRead: "mark as read",
      },
      validation: {
        taskRequirementIsRequired: "Performing condition is required",
        taskRequirementTooShort:
          "Requirement title is too short. Min 1 characters",
        taskRequirementTooLong:
          "Requirement title is too long. Max 200 characters",
        usersList: "At least one user is required",
        phoneIsInvalid: "Phone number is invalid",
        listIsRequired: "At least one item is required",
        reviewerRequired: "At least one Reviewer is required",
        participantsRequired: "At least one participant is required",
        arrayMinLength: "At least {{length}} is required",
        meetingAddressRequired: "Session address is required",
        required: "Required",
        durationMin: "Duration needs a minimum one minute",
        emailIsInvalid: "Email is invalid",
        titleIsRequired: "Title is required",
        titleIsTooLong: "Title is too long. Max 200 characters",
        titleIsTooShort: "Title is too short. Min 1 characters",
        titleEntityIsRequired: "Agenda’s title is required",
        titleEntityIsTooShort: "Agenda’s title is too short. Min 1 characters",
        titleEntityIsTooLong: "Agenda’s title is too long. Max 200 characters",
        elementIsRequired: "decision option is required",
        elementIsTooLong: "decision option is too long. Max 200 characters",
        elementIsTooShort: "decision option is too short. Min 1 characters",
        descriptionIsRequired: "Description is required",
        descriptionCurrentAndMaxLength:
          "Description has {{current}}/{{max}} characters",
        descriptionIsTooLong: "Description is too long. Max 2000 characters",
        descriptionIsTooShort: "Description is too short. Min 1 characters",
        passwordIsRequired: "Password is required",
        passwordMinLength: "Password is too short. Min 8 characters",
        passwordOneBigLetter: "Password must contain at least one big letter",
        passwordOneSmallLetter:
          "Password must contain at least one small letter",
        passwordOneNumber: "Password must contain at least one number",
        passwordRepeatNotMatch: "Passwords do not match",
        votingOptionIsRequired: "decision option is required",
        votingOptionIsTooLong:
          "decision option is too long. Max 100 characters",
        votingUsers: "Add at least one User",
        pastDate: "Date is past",
        listMinTwoAreRequired: "At least two items are required",
        oneSpeakerRequired: "At least one speaker is required",
        oneUserRequired: "At least one user is required",
      },
      taskForm: {
        conditionItem_one: "{{count}}st condition",
        conditionItem_two: "{{count}}nd condition",
        conditionItem_few: "{{count}}rd condition",
        conditionItem_other: "{{count}}th condition",
        usersTitle: "{{numbers}} Performers",
        saveTask: "Save Order",
        dueDate: "Date to perform",
        performingConditions: "Performing conditions",
        addElement: "Add element",
        taskDescription: "Order description",
        newTask: "New Order",
        taskCreated: "Order created",
        taskDeleted: "Order deleted successfully",
        conditions: "Conditions",
        beforeChoosePresenters:
          "Before you choose presenters, choose them as performers",
        requirementDeleted: "Requirement deleted",
      },
      votingForm: {
        conditionItem_one: "$t(الشرط رقم {{count}},arabicToEasternArabic) ",
        conditionItem_two: "$t(الشرط رقم {{count}},arabicToEasternArabic) ",
        conditionItem_few: "$t(الشرط رقم {{count}},arabicToEasternArabic) ",
        conditionItem_other: "$t(الشرط رقم {{count}},arabicToEasternArabic)",
        usersTitle: "Performers",
        saveTask: "ارسال الطلب",
        dueDate: "تاريخ الاستحقاق",
        performingConditions: "مهام الطلب",
        addElement: "إضافة خيار",
        taskDescription: "وصف الطلب",
        newTask: "طلب جديد",
        taskCreated: "تم إنشاء الطلب",
        taskDeleted: "تم حذف الطلب بنجاح",
        conditions: "الشروط",
        beforeChoosePresenters: "قبل اختيار مقدمي العرض، اخترهم كمؤدين",
        requirementDeleted: "تم الحذف",
        workspace: "Group",
      },
      milestoneForm: {
        milestoneCreated: "Order created",
        milestoneMovedToWorkspace: "Order moved to workspace",
        moveToWorkspace: "Move to Case Group",
      },
      tasksPage: {
        task: "Order",
        tasks: "Orders",
        assignedTo: "Assigned to",
        createCustomTask: "Create Order",
        status: "Status",

        categories: {
          all: "All current Orders",
          vote: "Surveys/Polls",
          surveys: "Surveys",
          signatures: "Signatures",
          docApprovals: "Document Approvals",
          custom: "Custom Orders",
          meeting: "Sessions",
          done: "Done",
        },
      },
      calendarPage: {
        calendar: "Calendar",
        newMeeting: "New Session",
        noResults: "No results",
        clearDates: "Clear dates",
        workspaceSelectPlaceholder: "Case Group",
        seeFuture: "See future sessions",
        seePast: "Sessions",
        googleCalendar: {
          connect: "Connect Google Calendar",
          disconnect: "Disconnect",
          connected:
            "Google Calendar connected. New sessions will be added automatically.",
          connectFailed: "Failed to connect Google Calendar",
          disconnected: "Google Calendar disconnected",
          disconnectFailed: "Failed to disconnect Google Calendar",
        },
      },
      taskPage: {
        finishAllRequirements: "Finish all requirements first",
        due: "due",
        priority: "priority",
        done: "Done",
        markAsDone: "Mark as done",
        markAsNotDone: "Mark as not done",
        taskStatusChanged: "Order status changed",
        requirementStatusChanged: "Requirement status changed",
        changeStatus: "Order status changed",
        reason: "Reason",
        rejectTask: "Reject Order",
        taskInfo: "To complete order, from More options select 'Edit'",
      },
      liveMeeting: {
        approximatedTime: "Approximated time",
        postponeText:
          "Choose new date for this session. Agenda and members will be the same.",
        postponeTitle: "Change meeting date",
        onGoing: "Ongoing",
        participants: "participants",
        participant: "participant",
        pleaseWait: "Please wait ...",
        noAccess: " You don’t have acces to this agenda section.",
        meetingNotStarted:
          "The meeting has not started yet. Wait for it to start...",
        join: "Join to the Order now",
        startMeeting: "Start Order",
        waitMoment: "Wait for moment",
        wantToStart: "Are you want to start?",
        wantToJoin: "Want to join?",
        agenda: "Agenda",
        quorumReached: "Quorum has been reached",
        quorumNotReached: "Quorum has not been reached",
        changeMeetingDate: "Change Order date",
        meetingMinutes: "Meeting minutes",
        endThisSectionAndStartNext: "End this section and start next",
        meetingEnded: "The Order has ended",
        backToPrevious: "Back to previous",
        noSlots: "Currently no slots available",
        bottomBar: {
          more: "More",
          agenda: "Agenda",
          record: "Record",
          mute: "Mute",
          unmute: "Unmute",
          stopVideo: "Stop video",
          startVideo: "Start video",
          screenShare: "Screen share",
          endCall: "Leave Session Room",
          leaveMeeting: "Leave Session",
          endMeeting: "End meeting",
          voting: "Decision",
          chat: "Chat",
          participants: "Participants",
          raiseHand: "Raise hand",
        },
      },
      votingsPage: {
        title: "Decisions",
        create: "Create",
        newVoting: "New Decision",
        before: "before",
        categories: {
          all: "All current surveys",
          votings: "Decisions",
          questionnaires: "Questionnaires",
        },
        votingSession: "Decision",
        questionnary: "Decision",
        meeting: "Session",
        barAttending: "Are you attending?",
        options: "Decision options",
        results: "Decision results",
        votingLiveRoomSwitch: "With live room?",
      },
      liveVoting: {
        saveNote: "Save note",
        votingLive: "Decision live",
        voting: "Decision",
        noVoting: "No Decision",
        noAvailableVotes: "You have no available votes or your votes are used",
        sendAnswer: "Send answer",
        startVoting: "Start Decision",
        endVoting: "End Decision",
        abstain: "Abstain from Decision",
        shares: "Shares",
        vote_zero: "{{count}} vote",
        vote_one: "{{count}} vote",
        vote_other: "{{count}} votes",
        people_zero: "{{count}} person",
        people_one: "{{count}} person",
        people_other: "{{count}} people",
        votingNotStarted:
          "The Decision has not started yet. Wait for it to start...",
        join: "Join to the Decision now",
        votingEnded: "Decision has ended",
        waitMoment: "Wait for moment",
        peopleNotVotedTitle: "Not voted",
        requestToVote: "Request to vote",
      },
      votingSummary: {
        approved: "Decision summary was approved",
        signed: "and signed",
        votingType: "Decision type",
        voting: "Decision",
        results: "Results",
        approvalRequestedAction: "Decision summary approve requested",
        approvedAction: "Decision summary approved",
        disapprovedAction: "Decision summary rejected",
        secret: "Secret",
        vote: "vote",
        votes: "votes",
        downloadedAction: "Decision summary downloaded",
        sentToSignAction: "Decision summary sent to sign",
        signedAction: "Signed Decision summary uploaded",
        addConclusion: "Add conclusion",
        editConclusion: "Edit conclusion",
        uploadTitle: "Sign meeting summary",
        uploadText: "Download summary, sign it and upload scan here to sign.",
        conclusionUpdated: "Updated Decision summary conclusion",
        conclusions: "Conclusions",
        editNote: "Edit note",
        creator: "Creator",
        submissionTitle: "Submission and approval",
        download: "Download Decision Summary",
        minutesSubmited: "The decision summary was approved by",
        inviteToAcceptance: "Send request approval",
        signedSummaries: "The decision summary was signed by",
        usersInvitedToApprove: "Users invited to approve",
      },
      meetingSummary: {
        addConclusion: "Add Session Decision",
        editConclusion: "Edit Session Decision",
        conclusion: "Session Decision",
        conclusionUpdated: "Session Decision updated",
        quorum: "Quorum reached",
        notReached: "Quorum has not been reached",
        signedSummaries: "Signed summaries",
        usersInvitedToApprove: "Users invited to approve",
        attendances: "Attendances",
        agenda: "Agenda",
        minutesApprovedAction: "Meeting minutes approved",
        minutesDisapprovedAction: "Meeting minutes rejected",
        minutesRequestedAction: "Meeting minutes approve requested",
        minutesSentToSignAction: "Meeting minutes sent to sign",
        minutesDownloadedAction: "Meeting summary downloaded",
        noteEditedAction: "Meeting notes edited",
        plannedTime: "Planned time",
        meetingNotFound: "Meeting not found",
        sign: "Sign",
        sendToSign: "Send to signature",
        accept: "Accept summary",
        reject: "Reject",
        votingNotEnded: "Decision is not ended",
        suggestChanges: "Suggest changes",
        inviteToAcceptance: "Invite to acceptance",
        approved: "Meeting summary was approved",
        signed: "and signed",
        presentUsers: "The following people were present",
        absentUsers: "The following people were absent",
        hideDocument: "Hide document",
        showDocument: "Show full document",
        submissionTitle: "Submission and approval of minutes",
        minutesSubmited: "Minutes submitted by",
        minutesApproved: "Minutes approved by",
        minutesRejected: "Minutes rejected by",
        presenters: "{{numbers}} Presenters",
        participants: "{{numbers}} Participants",
        votingResults: "Decision results",
        attachments: "Attachments",
        meetingType: "Meeting type",
        workspace: "Case Group",
        date: "Date",
        time: "Time",
        rejected: "Rejected",
        download: "Download summary",
        edit: "Edit summary",
        waitingForApproval: "Waiting for approval",
        waitingForSign: "Waiting for sign",
        day_one: "day",
        day_other: "days",
        week: "week",
        dontSetTime: "Dont set a time",
        addMembers: "Add members",
        editMode: "Edit mode",
        save: "Save changes",
        clickToEdit: "Click on the items you want to edit",
        uploadTitle: "Sign meeting summary",
        uploadText: "Download summary, sign it and upload scan here to sign.",
        timeTitle: "Set time for acceptance",
        timeText: "Select until when the summary can be accepted",
        waitUntillEditNoteFinished: "Wait untill it's finished to edit note",
        isEditingNow: "is editing now.",
        remote: "Remote",
        generateRecordingUrl: "Save the session recording",
        viewRecording: "View session recording",
      },
      maxFileSizeIs: "Max uploaded file should be {{size}}MB",
      liveParticipants: {
        noParticipants: "No participants",
        participants: "Participants",
        guests: "Guests",
        declined: "Declined",
        online: "Online users",
      },
      settings: {
        basic: "Basic",
        users: "Users",
        companyData: "Case data",
        basicDescription: "Informations about your cases",
        usersList: "Users list",
        usersDescription:
          "You can add, delete or edit users from your company.",
        rolesAndPermissions: "Roles & permisions",
        setPermissions: "Set permissions to roles in your app.",
      },
      linkingWorkspaces: {
        openModalText: "Link with other case group",
        modalTitle: "Choose case group to link",
        modalPlaceholder: "Type case group name",
        modalValidation: "Please select a case group",
        modalApprove: "Send a linking request",
        unlinkNow: "Unlink now",
        requested: "Requested",
        rejected: "Rejected",
        linked: "Linked",
        by: "by",
        invitationText: "wants to connect this case group with",
      },
      errorPage: {
        title: "Page not found",
        subtitle: "This page doesn't exist or was removed.",
        backButton: "Back to system dashboard",
      },
      lexicalEditor: {
        addComment: "Add comment",
        editComment: "Edit comment",
        yourComment: "Your comment",
        selectTextToComment: "Select the text you want to comment",
      },
      errors: {
        somethingWentWrong: "Something went wrong",
        errorCreatingTask: "Error creating Task",
        filesUploadError: "Error while uploading files",
        subsectionPostError: "Error while creating subsection",
      },
      logoutConfirm: "Are you sure you want to log out?",
    },
  },
  ar: {
    translation: {
      soon: "قريباً ...",
      invited_users: "المستخدمين المدعويين",
      fileTypeNotSupported: "امتداد الملف {{fileName}} غير مدعوم",
      acceptanceNeeded: "مطلوب الموافقة",
      search: "بحث",
      startSearching: "ابدأ البحث",
      multipleWorkspaces: "قضايا متعددة",
      abstain: "امتنع عن التصويت",
      yes: "نعم",
      no: "لا",
      beforeMeeting: "قبل الجلسة",
      select: "اختيار",
      offline: "غير متصل",
      from: "من",
      more: "خيارات",
      accept: "قبول",
      ago: "منذ",
      join: "انضمام",
      due: "مستحق",
      availableShares: "المشاركات المتوفرة",
      aprove: "موافقة",
      approved: "تمت الموافقة",
      started: "تم البدء",
      ended: "تم الانتهاء",
      invitationTo: "دعوة لـ",
      accepted: "تم القبول",
      addParticipants: "إضافة مشاركين",
      add: "إضافة",
      addSection: "إضافة قسم",
      addSubsection: "إضافة قسم فرعي",
      addFile: "إضافة مرفق",
      updateSubsection: "تحديث قسم فرعي",
      saveNewDate: "حفظ التاريخ الجديد ",
      agenda: "جدول الأعمال",
      required: "مطلوب",
      close: "إغلاق",
      logout: "تسجيل الخروج",
      resentcode: "إعادة إرسال الكود",
      invalidcode: "كود غير صالح",
      resetlinksuccess:
        "سنرسل لك رسالة بريد إلكتروني أو رسالة نصية قصيرة تحتوي على كود كي تتمكن من تسجيل الدخول",
      loginsuccess: "تم تسجيل الدخول بنجاح",
      hello: "مرحبًا",
      members: "الأعضاء",
      workspace: "المجموعة",
      meetingAddress: "مطلوب عنوان القضية",
      previousDay: "اليوم السابق",
      nextDay: "اليوم التالي",
      loadMore: "إظهار المزيد",
      delete: "حذف",
      editDescription: "تعديل الوصف",
      type: "نوع الطلب",
      public: "عام",
      private: "خاص",
      editMore: "تعديل",
      priority: "الأولوية",
      login: "تسجيل الدخول",
      reset: "إعادة تعيين",
      edit: "تعديل",
      update: "تحديث",
      end: "إنهاء",
      return: "عودة",
      forgotPassword: "هل نسيت كلمة المرور؟",
      seeSummary: "الاطلاع على ضبط الجلسة",
      seeVotingSummary: "الاطلاع على صك القرار",
      seeSummaryAndSign: "الاطلاع على ضبط الجلسة وتوقيعها",
      timestamp: "الطابع الزمني",
      mention: "تنبيه",
      decision: "قرار",
      remove: "إزالة",
      activate: "تفعيل",
      recentActivity: "أحدث الانشطة",
      resetPassword: "إعادة تعيين كلمة المرور",
      password: "كلمة المرور",
      save: "حفظ",
      draft: "مسودة",
      pending: "معلّق",
      seeDetails: "الاطلاع على التفاصيل",
      cancel: "إلغاء",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      origin: "المنشأ",
      wrong: "خطأ",
      replace: "استبدال",
      files: "المرفقات",
      reject: "رفض",
      rejectReason: "سبب الرفض",
      shares: "الأسهم",
      voteWeight: "أهمية القرار",
      location: "الموقع",
      privateMeeting: "جلسة خاص",
      newMeeting: "جلسة جديدة",
      editMeeting: "تعديل بيانات جلسة ",
      clearFilters: "مسح عوامل التصفية",
      createPoll: "إنشاء  قرار",
      createTask: "طلب جديد",
      createMeeting: "إنشاء جلسة",
      updateMeeting: "تحديث بيانات جلسة",
      localMeeting: "جلسة محلية",
      localTime: "الوقت المحلي",
      createDraft: "إنشاء مسودة",
      uploadDocument: "تحميل مستند",
      upload: "تحميل",
      onlyNumbers: "أرقام فقط",
      users: "المستخدمون",
      usersProfile: "الملف الشخصي للمستخدم",
      usersFrom: "نموذج المستخدم",
      role: "الدور",
      editProfile: "تعديل الملف الشخصي",
      addAll: "إضافة الجميع",
      allRoles: "جميع الأدوار",
      addNewUser: "إضافة مستخدم جديد",
      searchUser: "البحث عن مستخدم",
      noResults: "لا توجد نتائج",
      participant_other: "المشاركون",
      participant_one: "مشارك",
      guest_other: "الضيوف",
      guest_one: "زائر",
      fileError: "اسم الملف هذا موجود بالفعل",
      today: "اليوم",
      yesterday: "الأمس",
      older: "الأقدم",
      add_performers: "إضافة طرف",
      add_presenters: "إضافة مقدّم",
      addPresenter: "إضافة مقدّم",
      presenters: "المقدّمون",
      performers: "المؤدون",
      duration: "المدة",
      invitiationTo: "دعوة لـ",
      details: "التفاصيل",
      description: "الوصف",
      addDescription: "إضافة وصف",
      userNotActive: "هذا المستخدم غير نشط الآن.",
      performingConditions: "مهام الطلب",
      workspacePresencePlaceholder: "إذا كنت تريد رفض الدعوة، يُرجى تقديم سبب",
      workspacePrenanceValidation: "مطلوب ذكر السبب",
      invitationDeclined: "تم رفض الدعوة",
      invitationAccepted: "تم قبول الدعوة",
      reviewer_other: "$t( {{numbers}} المراجعون, arabicToEasternArabic)",
      reviewer_one: "المراجع",
      poolsAndVotings: "الأحكام",
      activeTasks: "الطلبات",
      pageingInfo: "إظهار {{from}} - {{to}} من {{total}}",
      viaEmail: "عبر البريد الإلكتروني",
      viaSms: "عبر الرسائل القصيرة",
      inactive: "غير نشط",
      quorum: "النصاب القانوني",
      vote_weight: "وزن القرار",
      invitations: "الدعوات",
      dueDate: "التاريخ المقرر",
      onlyUnread: "غير المقروء فقط",
      signature: "توقيع",
      currentLifecycle: "مدة التحكيم",
      titleOfMotion: "عنوان الطلب",
      permissionsChanged: "تغيرت أذوناتك",
      participants: "مشاركين",
      participant: "مشارك",
      maxFileSizeIs: "يجب أن يكون أقصى حجم للمرفق هو {size} ميجابايت",
      newMeetingRoles: {
        participants: "$t({{numbers}} المشاركون)",
        guests: "$t({{numbers}} الضيوف)",
        reviewers: "$t({{numbers}} المراجعون)",
      },
      quorumTypes: {
        majority_number: "أغلبية العدد بناءً على الشركة",
        majority_shares: "أغلبية الأسهم بناءً على الشركة",
        majority_number_company: "أغلبية العدد بناءً على الشركة",
        majority_shares_company: "أغلبية العدد بناءً على الشركة",
        majority_mixed: "أغلبية العدد والأسهم بناءً على الشركة",
        cumulative_voting: "القرار التراكمي",
        majority_number_workspace: "أغلبية العدد بناءً على أعضاء القضية",
        majority_shares_workspace: "أغلبية الأسهم بناءً على القضية",
      },
      errorPage: {
        title: "الصفحة غير موجودة ",
        subtitle: "هذه الصفحة غير موجودة أو تمت إزالتها.",
        backButton: "العودة إلى الصفحة الرئيسية ",
      },
      linkingWorkspaces: {
        openModalText: "ربط مجموعات قضايا أخرى",
        modalTitle: "اختيار المجموعة قضية لربطها",
        modalPlaceholder: "نوع القضية ",
        modalValidation: "برجاء اختيار المجموعة ",
        modalApprove: "ارسال رابط الطلب ",
        unlinkNow: "إزالة الربط الان",
        requested: "إلزامي",
        rejected: "مرفوض",
        linked: "مرتبط",
        by: "بواسطة",
        invitationText: "يريد توصيل المجموعة هذه بـ",
      },
      taskPriority: {
        low: "منخفض",
        normal: "عادي",
        important: "عالي",
        critical: "حساس",
      },
      milestoneForm: {
        milestoneCreated: "تم إنشاء طلب",
        milestoneMovedToWorkspace: "تمت إحالة الطلب لالمجموعة قضية ",
        moveToWorkspace: "النقل لقضية",
      },
      meetingOperation: {
        text: "نص",
        voting: "القرار",
        task: "طلب",
        votingResults: "نتائج جلسة القرار ",
        taskResults: "نتائج الطلب ",
      },
      taskStatus: {
        to_do: "الطلبات",
        in_progress: "قيد التنفيذ",
        rejected: "مرفوض",
        done: "تم",
      },
      language: {
        button: "اللغة",
        hello: "مرحبًا {{name}}",
        systemLanguage: "لغة النظام",
        english: "English",
        arabic: "العربية",
      },
      activity: {
        recentActivity: "أنشطة",
        days: {
          today: "اليوم، {{date}}",
          yesterday: "الأمس، {{date}}",
        },
      },
      textCreator: {
        placeholders: {
          title: "إدخال عنوان نصي",
          description: "إدخال وصف نصي",
        },
      },
      filters: {
        allTasks: "كل الطلبات",
        allVotings: "كل الأحكام",
        allMeetings: "كل الجلسات",
        assignedToMe: "الطلبات الخاصة بي",
        allWorkspaces: "جميع المجموعات",
        myWorkspaces: "المجموعات الخاصة بي",
        dueDate: {
          today: "مستحق اليوم",
          tomorrow: "مستحق غدًا",
          thisWeek: "مستحق في الأسبوع الحالي",
          thisMonth: "مستحق في الشهر الحالي",
          overdue: "متأخر عن الاستحقاق",
        },
      },
      setPassword: {
        setNew: "تعيين كلمة مرور جديدة",
        passwordSet: "إنشاء كلمة مرور جديدة",
        submit: "تعيين واحدة جديدة",
      },
      votingSummary: {
        approved: "اعتمد ملخص الجلسة",
        signed: "والتوقيع",
        votingType: "نوع جلسة مداولة القرار",
        voting: "نتائج جلسة مداولة القرار",
        results: "النتائج",
        approvalRequestedAction: "تم طلب الموافقة على ملخص صك القرار",
        approvedAction: "تم اعتماد صك القرار ",
        disapprovedAction: "تم رفض صك القرار",
        secret: "سري ",
        vote: "قرار ",
        votes: "الأصوات",
        downloadedAction: "تم تحميل صك القرار ",
        sentToSignAction: "ارسال صك القرار للتوقيع ",
        signedAction: "توقيع صك القرار وملخصه ورفعه",
        uploadTitle: "توقيع محضر الاجتماع ",
        uploadText: "تحميل المحضر وتوقيعه ورفعه النسخة الموقعة ",
        addConclusion: "إضافة خاتمة",
        editConclusion: "التعديل على الخاتمة ",
        conclusionUpdated: "تحديث نتائج صك القرار",
        conclusions: "الخاتمة",
        editNote: "تعديل الملاحظة",
        creator: "المنشئ",
        submissionTitle: "تقديم صك القرار والموافقة عليه",
        download: "تنزيل صك القرار",
        minutesSubmited: "تم اعتماد صك القرار من قبل",
        inviteToAcceptance: "ارسال طلب اعتماد صك القرار",
        signedSummaries: "صك القرار موّقع من قبل",
        usersInvitedToApprove: "المستخدمين المدعويين للإعتماد",
      },
      voting: {
        heedMyVote: "توجيه صوتي",
        votingOwner: "منشئ جلسة مداولة القرار",
        sharesUsed: "الاسهم المستخدمة",
        participants: "المشاركون",
        voteSecrecy: "سرية القرار",
        quorumType: "نوع النصاب القانوني",
        givePower: "منح دورك لـ {{name}}",
        requestVote: "طلب {{name}} للقرار",
        votingType: "نوع القرار",
        optionsToChoose: " عدد الخيارات المراد تحديدها",
        optionsToWin: "عدد الخيارات المراد الفوز بها",
        saveVoting: "إنشاء قرار",
        voting: "القرار",
        addElement: "إضافة خيار",
        users: "المستخدمون",
        addUser: "إضافة مستخدم",
        label: {
          dateStart: "تاريخ بدء جلسة مداولة القرار",
          dateEnd: "تاريخ انتهاء جلسة مداولة القرار",
          votingResult: "نتائج القرار",
        },
        placeholders: {
          name: "إدخال عنوان القرار ",
          option: "إدخال خيار القرار",
          note: "ستكون المعلومات المضافة في هذا الحقل مرئية كملخص لنتيجة القرار",
        },
        votingRoles: {
          voting_owner: "المالك",
          voting_voter: "المصوّت",
          voting_commentator: "المعلّق",
          voting_viewer: "العارض",
          voting_eliminated: "تم الإقصاء",
        },
        actionMessages: {
          created: "تم إنشاء قرار جديد",
          updated: "تم تحديث القرار",
          deleted: "تم حذف القرار",
          statusUpdated: "تم تحديث الحالة",
          noteSaved: "تم حفظ الملاحظات",
          voteTransferred: "تم تحويل  حق القرار",
          remindNotificationSent: "تم إرسال تذكير",
        },
      },
      profile: {
        title: "الملف الشخصي",
        email: "البريد الإلكتروني",
        phone: "الهاتف",
        memberOf: "عضو في ",
        location: "الموقع",
      },
      rolesSelect: {
        general: "عام",
        votings: "الأحكام",
        meetings: "الجلسات",
      },
      twoStepAuth: {
        title: "المصادقة في خطوتين ",
        info: "إدخال كود التحقق قمنا بإرساله إلى",
      },
      companyForm: {
        contactInformations: "معلومات الاتصال",
        sharesTitle: "الاسهم",
      },
      roles: {
        secretary: "أمين السر",
        global_1733145008: "ممثل المنشأة",
        executive_mng: "مُحتكم",
        admin: "المشرف",
        board_director: "رئيس هيئة التحكيم",
        shareholder: "مُحكم",
        independent: "مُحتكم ضده/ا",
        executive: "وكيل طرف",
        guest: "خبير",
        regularGeneralAssembly: "الجمعية العمومية العادية",
        extraordinaryGeneralAssembly: "الجمعية العمومية غير العادية",
        manager: "مدير تنفيذي",
        member: "عضو",
        chief: "الرئيس التنفيذي",
        boardOfDirectors: "مجلس الإدارة",
        executiveManagement: "الإدارة التنفيذية",
        auditor: "مدقق",
        waiting_for_account: "بانتظار حساب",
        meeting_organizer: "منظم اجتماعات",
        meeting_shareholder: "المساهم",
        meeting_board_of_directors: "مجلس الإدارة",
        meeting_executive_management: "الإدارة التنفيذية",
        meeting_independent_board_member: "عضو مجلس إدارة مستقل",
        meeting_executive_brd_mbr_com: "عضو مجلس إدارة تنفيذي مع اللجان",
        meeting_auditor: "مدقق",
        meeting_regular_general_assembly: "الجمعية العمومية العادية",
        meeting_extraordinary_general_assembly: "الجمعية العمومية غير العادية",
        voting_owner: "أمين السر",
        voting_voter: "مصّوت",
        voting_commentator: "معلّق",
        voting_viewer: "مشاهد",
        voting_eliminated: "تم الإقصاء",
        meeting_owner: "رئيس هيئة التحكيم",
        meeting_admin: "أمين السر",
        meeting_secretary: "مُحكم",
        meeting_attendee: "محتكم",
        meeting_guest: "خبير",
        meeting_viewer: "مستمع",
        some_custom_role_mm: "بعض الأدوار المخصصة MM",
      },
      notification: {
        remind: "قم بتذكيري خلال 10 دقائق",
        meeting: {
          invitation: {
            inviting: "دعوة شخص: {{name}}",
            date: "التاريخ: {{date}}",
            form: "النموذج: ",
          },
        },
      },
      meetingRoles: {
        secretary: "سكرتير",
        organiser: "المنظم",
        guest: "الضيف",
      },
      userTypes: {
        internal: "داخلي",
        external: "خارجي",
      },
      menu: {
        home: "لوحة التحكم",
        workspaces: "إدارة مجموعات القضية",
        calendar: "التقويم التحكيمي",
        messages: "الرسائل",
        documents: "المستندات",
        tasks: "الطلبات",
        votings: "الأحكام",
        pollsAndVotings: "الأحكام",
        styleguide: "دليل الأسلوب",
        minimize: "تصغير القائمة",
        settings: "الإعدادات",
        adminDashboard: "لوحة تحكم الأدمن",
      },
      dashboards: {
        goodMorning: "مرحبا",
        quickActions: "أبرز الخدمات",
        pendingActions: "الطلبات النشطة",
        newRequests: "طلبات جديدة",
        comingUpNext: "التالي",
        actionItems: "ملخص القضية",
        activityFromWorkspaces: "أنشطة القضية",
        workspacesUpdates: "تحديثات القضية",
        urgent: "طلب عاجل",
      },
      registerForm: {
        fullName: "اسم المستخدم",
        role: "الدور",
        userType: "نوع المستخدم",
        addUser: "إضافة مستخدم",
        caseName: "اسم القضية",
      },
      loginWithNafath: "تسجيل الدخول عن طريق النفاذ الوطني",
      somethingWentWrong:
        "لتسجيل الدخول عبر خدمة النفاذ الوطني يجب عليك أولاً إدخال رقم الهوية الوطنية في ملفك الشخصي!",
      nationalId: "رقم الهوية السعودي",
      sendOtp: "ارسال",
      createMeetingForm: {
        choosePerformersFirst: "اضف أولًا المسؤولين ومن ثم عارضين البند ",
        chooseVotingBefore: "اختر القرار قبل الجلسة ",
        chooseTaskBefore: "اختر الطلب قبل الجلسة ",
        resultsOfTask: "نتائج الطلب قبل الجلسة ",
        resultOfVoting: "نتائج القرار قبل الجلسة ",
        typeTaskName: "نوع الطلب ",
        typeVotingName: "نوع القرار",
        subsectionDuration: "المدة الزمنية ",
        updateSubsection: "تحديث القسم ",
        addSelected: "اضافة الاختيار ",
        guestModal: "دعوة عضو خارجي",
        guestModalAdditionalText:
          "تحتاج إلى حفظ الجلسة، حتى تقوم بدعوة عضو خارجي.",
        meetingDeleted: "تم حذف الجلسة",
        deleteConfirmation: "هل تريد بالتأكيد حذف {{entity}}؟",
        majorityOfShares: "أغلبية المشاركات",
        majorityOfNumber: "أغلبية العدد",
        majorityOfNumberAndShares: "أغلبية العدد والمشاركات",
        meetingCreatorTitle: "مُنشئ الجلسة",
        titleRequired: "مطلوب إدخال العنوان ",
        enterTitle: "ادخل عنوان الجلسة",
        enterDescription: "أدخل وصفًا اختياريًا الجلسة",
        enterMeetingAddress: "أدخل عنوان الجلسة",
        frequencyDaysRequired: "حدد أيامًا للتكرار",
        meetingCreated: "تم إنشاء الجلسة",
        meetingUpdated: "تم تحديث الجلسة",
        workspace: "المجموعة",
        quorumTypes: {
          majority_number: "أغلبية العدد",
          majority_shares: "أغلبية الأسهم",
          majority_number_company: "أغلبية العدد بناءً على الشركة",
          majority_shares_company: "أغلبية العدد بناءً على الشركة",
          majority_mixed: "أغلبية العدد والأسهم بناءً على الشركة",
          cumulative_voting: "القرار التراكمي",
          majority_number_workspace: "أغلبية العدد بناءً على أعضاء القضية",
          majority_shares_workspace: "أغلبية الأسهم بناءً على القضية",
        },
        enterTitlePlaceholder: "إدخال العنوان",
        sectionTitleRequired: "مطلوب إدخال عنوان القسم ",
        titleLengthErrorMax: "العنوان طويل جدًا. الحد الأقصى 100 حرف",
        titleLengthErrorMin: "العنوان قصير جدًا. الحد الأدنى حرف واحد",
        sectionDeleteConfirmation: "هل تريد بالتأكيد حذف القسم؟",
        updated: "تم التحديث:",
        secondsAgo: "منذ {{seconds}} ثوانٍ",
        minutesAgo: "منذ {{seconds}} من الدقائق",
        updateNow: "التحديث الآن",
        saveNow: "احفظ الان",
        peopleInMeeting: "أعضاء الجلسة",
        participantList: {
          removeUserModalTitle: "حذف المشاركين",
          removeUserModalHeader: "أنت على وشك حذف {{name}} من الجلسة",
          removeUserModalSectionText: "هذا المستخدم حالياً متواجد:",
          removeUserModalSubsectionText: "هذا المستخدم أيضاً مشارك:",
          confirmationMessage:
            "If you remove the user, they will be removed from the agenda section(s) but will not be removed from any assigned tasks or votes. You will need to remove them manually from the assigned events.",
          ok: "OK",
          cancel: "Cancel",
          genericConfirmationMessage:
            "Are you sure you want to remove {{name}} from سession?",
        },
        selectCalculationMethod: "اختر طريقة الحساب",
        type: "مكان الإنعقاد",
      },
      viewMeeting: {
        noAccessSection: "ليس لديك حق الوصول إلى هذا القسم",
        agenda: {
          lastEdited: "تم آخر تعديل بواسطة {{name}}",
        },
      },
      meetingTypes: {
        by_presence: "حضوري",
        remote: "عن بُعد",
      },
      meetingMessages: {
        remindMeIn: "قم بتذكيري خلال {{min}} من الدقائق",
        startingInMinutes_one: "يبدأ خلال دقيقة واحدة",
        startingInMinutes: "يبدأ خلال",
        years: "سنين",
        months: "شهور",
        days: "أيام",
        hours: "ساعات",
        minutes: "دقائق",
        sentToApprova: "تم إرسال الجلسة للموافقة",
        startReview: "تم بدء مراجعة الجلسة",
        approve: "تمت الموافقة على الجلسة",
        disapprove: "تم رفض الجلسة",
        acceptPresence: "تم قبول الحضور ",
        rejectPresence: "تم رفض الحضور ",
        successNextSection: "القسم التالي",
        successPreviousSection: "القسم السابق",
        successSectionMeetingMinutes: "تم حفظ محضر الجلسة الحالي",
        meetingPostponedAction: "تم تأجيل موعد الجلسة",
        sentForApproval: "تم تقديم الطلب للموافقة عليه",
      },
      meetingAction: {
        approvalSend: "إرسال المسودة للموافقة",
        approval: "الموافقة",
        disapproval: "الرفض",
        startReview: "بدء المراجعة",
      },
      meetingLabels: {
        reason: "السبب",
        rejectReason: "سبب الرفض:",
        disapprovalTitle: "رفض الجلسة: ",
        rejectInvitationTitle: "رفض دعوة الجلسة: ",
      },
      userRolesSettings: {
        protectedRoleError: "لا يمكنك حذف هذا الدور",
        assignedRoleError: "لا يمكنك حذف دور معين للمستخدم",
        protectedRole: "لا يمكنك حذف هذا الدور",
        requiredPermissions: "الأذونات المطلوبة",
        rolesPageTitle: "الأدوار والصلاحيات",
        searchPlaceholder: "البحث عن صلاحية معينة",
        newRoleAdded: "تمت إضافة دور جديد",
        roleName: "اسم الدور",
        roleDeleted: "تم حذف الدور",
        roleModalDelete: "هل تريد بالتأكيد حذف الدور؟",
        roleNameMaxLength: "الحد الأقصى 50 حرفًا",
        roleDescriptionModalTitle: "تعديل وصف الدور",
        roleUpdated: "تم تحديث الدور",
      },
      userEditForm: {
        sharesTitle: "الأسعم",
        sharesToBig: "يجب أن يكون أقل من",
        totalShares: "إجمالي عدد الأسهم",
        sharesToBigMore:
          "إذا كنت ترغب في إضافة مزيد من الأسهم إلى هذا المستخدم، قم أولاً بتغيير النسبة المئوية للمشاركات لمستخدم آخر وفقًا لذلك",
        sharesToSmall: "يجب أن تكون أكبر من أو تساوي 0",
        sharesInCompany: "عدد الأسهم في الشركة",
        quorumInNumber: "عدد النصاب القانوني",
        contactInformations: "معلومات الاتصال",
        emailAddress: "عنوان البريد الإلكتروني:",
        phoneNumber: "رقم الهاتف",
        location: "الموقع",
        roleAndPower: "الدور والصلاحية خلال الاجتماعات",
        save: "حفظ التغييرات",
        _2fa: "عامل المصادقة الثاني",
        workspaceMembership: "المجموعات المنضم لها",
        showUserWorkspaces: "المجموعات المنضم لها",
        votingWeight: "وزن القرار",
        nationalId: "رقم بطاقة الهوية المدنية السعودية",
      },
      createWorkspaceForm: {
        deleteConformation: "هل تريد بالتأكيد حذف المجموعة هذه؟",
        usersAdded: "تمت دعوة المستخدمين إلى المجموعة",
        nameRequired: "مطلوب إدخال الاسم",
        enterName: "مطلوب إدخال اسم المجموعة",
        description: "وصف المجموعة (اختياري)",
        startTime: "بدءًا من",
        endTime: "إلى",
        createWorkspace: "إنشاء مجموعة",
        newWorkspace: "مجموعة جديدة",
        members: "$t(الأعضاء {{numbers}})",
        addMember: "إضافة عضو",
        workspaceCreated: "تم إنشاء المجموعة",
        workspaceUpdated: "تم تحديث المجموعة",
        workspaceDeleted: "تم حذف المجموعة",
        updateWorkspace: "تحديث المجموعة",
        photoText: "صورة المجموعة",
        nameTooLong: "الاسم طويل جدًا. الحد الأقصى 50 حرفًا",
        descriptionTooLong: "الوصف طويل جدًا. الحد الأقصى 200 حرف",
        endDateRequired: "مطلوب إدخال تاريخ الانتهاء ",
        userDeleted: "تم حذف المستخدم",
        workspace: {
          named: "المجموعة: {{name}}",
          unnamed: "المجموعة أخرى",
        },
      },
      addGuest: {
        title: "إضافة ضيف",
        submit: "إضافة ضيف",
        addedGuestError: "تمت إضافة الضيف بالفعل",
        labels: {
          name: "الاسم",
          email: "عنوان البريد الإلكتروني:",
          phone: "رقم الهاتف",
          invitationText: "نص الدعوة",
        },
        placeholders: {
          name: "إدخال الاسم",
          email: "إدخال عنوان البريد الإلكتروني",
          phone: "إدخال رقم الهاتف",
          invitationText: "إدخال نص الدعوة",
        },
      },
      workspaces: {
        lifeCycle: "مدة التحكيم",
        seeArchive: "الاطلاع على الأرشيف",
        workspace: "مجموعة جديدة",
        createWorkspace: "إنشاء مجموعة جديدة",
        memberOf: "$t(المجموعات {{count}})",
        meetings: "الجلسات",
        addMeeting: "إضافة جلسة",
      },
      notifications: {
        title: "الإشعارات",
        noData: "ليس لديك إشعارات جديدة",
        markAllRead: "تمييز الجميع كمقروء",
        markAsRead: "تمييز كمقروء",
      },
      validation: {
        titleEntityIsTooLong: "عنوان الأجندة طويل جدًا. 200 حرف كحد أقصى",
        taskRequirementIsRequired: "حقل العنوان إلزامي",
        taskRequirementTooShort:
          "المحتوى المدخل قصير جدًا، برجاء ادخل حرف على الأقل",
        taskRequirementTooLong: "المحتوى المدخل طويل جدًا، الحد الأقصى ٢٠٠ حرف",
        usersList: "مطلوب مستخدم واحد على الأقل",
        meetingAddressRequired: "مطلوب عنوان الجلسة",
        titleEntityIsRequired: "مطلوب جدول أعمال العنوان",
        titleEntityIsTooShort:
          "جدول أعمال العنوان قصير جدًا. الحد الأدنى حرف واحد",
        titleEntityIsToShort:
          "جدول أعمال العنوان قصير جدًا. الحد الأدنى حرف واحد",
        elementIsRequired: "مطلوب إدخال خيار القرار",
        elementIsTooLong: "خيار القرار طويل جداً الحد الأقصى 200 حرف",
        elementIsTooShort: "خيار القرار قصير جدًا. الحد الأدنى حرف واحد",
        phoneIsInvalid: "رقم الهاتف غير صالح",
        listIsRequired: "مطلوب بند واحد على الأقل",
        reviewerRequired: "مطلوب مراجع واحد على الأقل",
        participantRequired: "مطلوب مشارك واحد على الأقل",
        required: "مطلوب",
        durationMin: "ينبغي أن تكون المدة دقيقة واحدة على الأقل",
        emailIsInvalid: "البريد الإلكتروني غير صالح",
        titleIsRequired: "مطلوب إدخال العنوان ",
        titleIsTooLong: "العنوان طويل جدًا. الحد الأقصى 200 حرف",
        titleIsTooShort: "العنوان قصير جدًا. الحد الأدنى حرف واحد",
        descriptionIsRequired: "مطلوب إدخال الوصف",
        descriptionCurrentAndMaxLength:
          "الوصف يحتوي على {{current}}/{{max}} حرف",
        descriptionIsTooLong: "الوصف طويل جدًا. الحد الأقصى 200 حرف",
        descriptionIsTooShort: "الوصف قصير جدًا. الحد الأدنى حرف واحد",
        passwordIsRequired: "مطلوب إدخال كلمة المرور",
        passwordMinLength: "كلمة المرور قصيرة جدًا. الحد الأدنى 8 أحرف",
        passwordOneBigLetter:
          "يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل",
        passwordOneSmallLetter:
          "يجب أن تحتوي كلمة المرور على حرف صغير واحد على الأقل",
        passwordOneNumber: "يجب أن تحتوي كلمة المرور على رقم واحد على الأقل",
        passwordRepeatNotMatch: "كلمات المرور غير متطابقة",
        votingOptionIsRequired: "مطلوب إدخال خيار القرار",
        votingOptionIsTooLong: "خيار القرار طويل جداً الحد الأقصى 100 حرف",
        votingUsers: "إضافة مستخدم واحد على الأقل",
        pastDate: "التاريخ قديم",
        listMinTwoAreRequired: "مطلوب بندان على الأقل",
        arrayMinLength: "على الأقل {{length}} عنصر",
        oneUserRequired: "مطلوب على الأقل مؤدٍ واحد",
        oneSpeakerRequired: "مطلوب على الأقل مقدّم واحد",
      },
      taskForm: {
        conditionItem_one: "$t(الشرط رقم {{count}},arabicToEasternArabic) ",
        conditionItem_two: "$t(الشرط رقم {{count}},arabicToEasternArabic) ",
        conditionItem_few: "$t(الشرط رقم {{count}},arabicToEasternArabic) ",
        conditionItem_other: "$t(الشرط رقم {{count}},arabicToEasternArabic)",
        usersTitle: "الأطراف",
        saveTask: "ارسال الطلب",
        dueDate: "تاريخ الاستحقاق",
        performingConditions: "مهام الطلب",
        addElement: "إضافة خيار",
        taskDescription: "وصف الطلب",
        newTask: "طلب جديد",
        taskCreated: "تم إنشاء الطلب",
        taskDeleted: "تم حذف الطلب بنجاح",
        conditions: "الشروط",
        beforeChoosePresenters: "قبل اختيار مقدمي العرض، اخترهم كمؤدين",
        requirementDeleted: "تم الحذف",
      },
      votingForm: {
        conditionItem_one: "$t(الشرط رقم {{count}},arabicToEasternArabic) ",
        conditionItem_two: "$t(الشرط رقم {{count}},arabicToEasternArabic) ",
        conditionItem_few: "$t(الشرط رقم {{count}},arabicToEasternArabic) ",
        conditionItem_other: "$t(الشرط رقم {{count}},arabicToEasternArabic)",
        usersTitle: "متخذي القرار",
        saveTask: "ارسال الطلب",
        dueDate: "تاريخ الاستحقاق",
        performingConditions: "مهام الطلب",
        addElement: "إضافة خيار",
        taskDescription: "وصف الطلب",
        newTask: "طلب جديد",
        taskCreated: "تم إنشاء الطلب",
        taskDeleted: "تم حذف الطلب بنجاح",
        conditions: "الشروط",
        beforeChoosePresenters: "قبل اختيار مقدمي العرض، اخترهم كمؤدين",
        requirementDeleted: "تم الحذف",
        workspace: "المجموعة",
      },
      tasksPage: {
        task: "الطلب",
        tasks: "الطلبات",
        assignedTo: "تم التعيين إلى",
        createCustomTask: "طلب جديد",
        status: "الحالة",
        categories: {
          all: "جميع الطلبات الحالية",
          vote: "طلب عارض",
          surveys: "استطلاعات الرأي / استطلاعات الرأي",
          signatures: "طلب توقيع أو موافقة",
          docApprovals: "طلب مستند",
          custom: "آخرى",
          done: "مكتمل",
          meeting: "طلب إيداع مذكرة",
        },
      },
      calendarPage: {
        calendar: "التقويم",
        newMeeting: "جلسة جديدة",
        noMeetings: "لا توجد جلسات",
        clearDates: "مسح التواريخ",
        workspaceSelectPlaceholder: "القضايا",
        seePast: "الجلسات السابقة",
        seeFuture: "عرض الجلسات المقبلة",
        googleCalendar: {
          connect: "ربط تقويم Google",
          disconnect: "إلغاء الربط",
          connected: "تم ربط تقويم Google. ستُضاف الجلسات الجديدة تلقائيًا.",
          connectFailed: "فشل ربط تقويم Google",
          disconnected: "تم إلغاء ربط تقويم Google",
          disconnectFailed: "فشل إلغاء ربط تقويم Google",
        },
      },
      taskPage: {
        due: "مستحق",
        priority: "الأولوية",
        markAsDone: 'وضع علامة "مكتمل"',
        markAsNotDone: 'وضع علامة "غير مكتمل"',
        done: "مكتمل",
        taskStatusChanged: "تم تغيير حالة الطلب",
        requirementStatusChanged: "تم تغيير حالة المتطلب ",
        changeStatus: "تم تغيير حالة الطلب",
        reason: "السبب",
        finishAllRequirements: "قم بإنهاء جميع الحقول الإلزامية أولاً",
        rejectTask: "رفض الطلب",
        taskInfo: "لإكمال الطلب، من قائمة الخيارات اختر 'تعديل'",
      },
      liveMeeting: {
        postponeText:
          "اختر تاريخًا جديدًا لهذه الجلسة. الأجندة والمدعويين مكررين",
        postponeTitle: "تغيير موعد الجلسة",
        pleaseWait: "يُرجى الانتظار...",
        noAccess: "لا يمكنك الوصول إلى هذا القسم من جدول الأعمال.",
        meetingNotStarted: "لم تبدأ الجلسة بعد. انتظر حتى يتم البدء.......",
        participants: "المشاركون",
        participant: "مشارك",
        join: "انضم إلى الجلسة الآن",
        onGoing: "جاري التنفيذ",
        quorumReached: "اكتمل النصاب",
        quorumNotReached: "لم يكتمل النصاب",
        changeMeetingDate: "تغيير موعد الجلسة",
        meetingEnded: "انتهت الجلسة",
        startMeeting: "بدأت الجلسة",
        waitMoment: "انتظر دقيقة",
        wantToJoin: "هل تريد الانضمام؟",
        wantToStart: "هل تريد أن تبدأ؟",
        agenda: "جدول الأعمال",
        meetingMinutes: "محضر الجلسة",
        endThisSectionAndStartNext: "قم بإنهاء هذا القسم ثم ابدأ في التالي ",
        backToPrevious: "العودة الى القسم السابق",
        bottomBar: {
          more: "أكثر",
          agenda: "جدول الأعمال",
          record: "تسجيل",
          mute: "صامت",
          unmute: "غير صامت",
          stopVideo: "إيقاف الكاميرا",
          startVideo: "تشغيل الكاميرا",
          screenShare: "مشاركة الشاشة",
          endCall: "مغادرة الجلسة",
          leaveMeeting: "مغادرة الجلسة",
          endMeeting: "إنهاء الجلسة",
          voting: "التصويت",
          chat: "دردشة",
          participants: "المشاركون",
        },
      },
      votingsPage: {
        votingLiveRoomSwitch: "مع غرفة مباشرة",
        title: "الأحكام",
        create: "إنشاء",
        newVoting: "إنشاء قرار",
        before: "قبل",
        categories: {
          all: "جميع الاستطلاعات الحالية",
          votings: "الأحكام",
          questionnaires: "إستفتاءات",
        },
        votingSession: "جلسة القرار",
        questionnary: "استفتاء",
        meeting: "الاجتماع",
        barAttending: "هل ستحضر؟",
        options: "خيارات القرار",
        results: "نتائج جلسة القرار",
        votingUserInfo:
          "في حال وجود أكثر من مشارك تم تأكيد مشاركته يمكن الضغط على صورته لتفويضه بالتصويت نيابة عنك!",
      },
      liveVoting: {
        saveNote: "حفظ الملاحظة ",
        votingLive: "قرار مباشر",
        voting: "القرار",
        noVoting: "لا يوجد قرار",
        noAvailableVotes: "ليس لديك أي مشاركات متاحة أو تم استخدام مشاركاتك",
        sendAnswer: "إرسال الإجابة",
        startVoting: "بدء جلسة مداولة القرار",
        endVoting: "إنهاء جلسة مداولة القرار",
        abstain: "الامتناع عن إبداء رأي",
        shares: "الأسهم",
        vote_zero: "$t({{count}} أسهم)",
        vote_one: "$t({{count}} قرار)",
        vote_two: "$t({{count }} قراران",
        vote_few: "$t( {{count}} قرارات)",
        vote_other: "$t( {{count}} الأصوات)",
        votingNotStarted: "لم يبدأ القرار بعد. انتظر حتى يتم البدء.......",
        join: "انضم إلى القرار الآن",
        votingEnded: "تم إنهاء القرار",
        waitMoment: "انتظر دقيقة",
        people_zero: "$t({{count}} شخص)",
        people_one: "$t({{count}} شخص)",
        people_other: "{{count}} أشخاص",
        requestToVote: "طلب القرار",
        peopleNotVotedTitle: "أشخاص لم يصّوتوا بعد",
      },
      meetingSummary: {
        votingNotEnded: "جلسة القرار لم تنتهي",
        attendances: "الحضور",
        agenda: "جدول الأعمال",
        minutesApprovedAction: "تمت الموافقة على ضبط الجلسة",
        minutesDisapprovedAction: "تم رفض ضبط الجلسة",
        minutesRequestedAction: "مطلوب الموافقة على ضبط الجلسة",
        minutesSentToSignAction: "تم إرسال ضبط الجلسة للتوقيع",
        minutesDownloadedAction: "تم تنزيل ضبط الجلسة",
        noteEditedAction: "تم تعديل ملاحظات الجلسة",
        plannedTime: "الوقت المخطط",
        meetingNotFound: "لم يتم العثور على جلسات ",
        sign: "توقيع",
        sendToSign: "الإرسال لوضع التوقيع",
        accept: "الموافقة على ضبط الجلسة",
        reject: "رفض",
        suggestChanges: "اقتراح تغييرات",
        inviteToAcceptance: "دعوة للموافقة",
        approved: "تمت الموافقة على ضبط الجلسة",
        signed: "وتم التوقيع",
        presentUsers: "حضر الأشخاص المذكورين أدناه",
        absentUsers: "غاب الأشخاص المذكورين أدناه",
        hideDocument: "إخفاء مستند",
        showDocument: "إظهار المستند كاملاً",
        submissionTitle: "تقديم ضبط الجلسة والموافقة عليه",
        minutesSubmited: "قدّم ضبط الجلسة",
        minutesApproved: "وافق على ضبط الجلسة كلاً من",
        minutesRejected: "رفض ضبط الجلسة",
        presenters: "$t( المقدّمون {{numbers}}, arabicToEasternArabic)",
        participants: "$t( المشاركون {{numbers}}, arabicToEasternArabic)",
        votingResults: "نتائج القرار",
        attachments: "المرفقات",
        meetingType: "نوع الجلسة",
        workspace: "القضية",
        date: "التاريخ",
        time: "الوقت",
        rejected: "مرفوض",
        download: "تنزيل ضبط الجلسة",
        edit: "تعديل محضر الجلسة",
        waitingForApproval: "بانتظار الموافقة",
        waitingForSign: "بانتظار التوقيع",
        day: "يوم",
        day_one: "يوم",
        week: "أسبوع",
        dontSetTime: "عدم تحديد موعد",
        addMembers: "إضافة أعضاء",
        editMode: "وضع التعديل",
        save: "حفظ التغييرات",
        clickToEdit: "انقر فوق العناصر التي ترغب في تعديلها",
        uploadTitle: "توقيع ضبط الجلسة",
        uploadText:
          "قم بتنزيل ضبط الجلسة والتوقيع عليه وتحميل صورة ضوئية له هنا.",
        timeTitle: "تحديد موعد للموافقة",
        timeText: "حدد الموعد الذي سيتم قبول ضبط الجلسة فيه",
        quorum: "اكتمل النصاب",
        notReached: "لم يكتمل النصاب",
        signedSummaries: "ضبط الجلسة موّقع من قبل",
        usersInvitedToApprove: "المستخدمين المدعويين للإعتماد",
        day_other: "أيام",
        addConclusion: "إضافة قرار",
        editConclusion: "التعديل على قرار الجلسة ",
        conclusionUpdated: "تحديث نتائج القرار الملخص",
        conclusion: "حكم الجلسة",
        editNote: "تعديل الملاحظة",
        approvedAT: "في",
        generateRecordingUrl: "حفظ تسجيل الجلسة",
        viewRecording: "مشاهدة الجلسة المسجلة",
      },
      liveParticipants: {
        noParticipants: "لا يوجد مشاركون",
        participants: "المشاركون",
        guests: "الضيوف",
        declined: "تم الرفض",
        online: "المستخدمون المتصلون",
      },
      settings: {
        basic: "الأساسي",
        users: "المستخدمون",
        companyData: "بيانات القضية",
        basicDescription: " معلومات عن القضية",
        usersList: "قائمة المستخدمين",
        usersDescription: " يمكنك إضافة أو حذف أو تعديل المستخدمين من شركتك",
        rolesAndPermissions: "الأدوار والصلاحيات",
        setPermissions: "تعيين أذونات الأدوار في تطبيقك.",
      },
      errors: {
        somethingWentWrong: "حدث خطأ ما",
        errorCreatingTask: "خطأ في إنشاء المهمة",
        filesUploadError: "خطأ في تحميل المرفقات",
        subsectionPostError: "خطأ في إنشاء القسم الفرعي",
      },
      logoutConfirm: "هل متأكد أنك تريد تسجيل الخروج؟",
    },
  },
};

//eslint-disable-next-line
const compareObjects = (
  enObj: {
    [x: string]: any;
  },
  arObj: {
    [x: string]: any;
  },
  path = ""
) => {
  for (const key of Object.keys(enObj)) {
    if (!(key in arObj)) {
      console.log(`${path}${key}: ${enObj[key]}`);
      continue;
    }

    if (typeof enObj[key] === "object") {
      //eslint-disable-next-line
      compareObjects(enObj[key], arObj[key], `${path}${key}.`);
    }
  }
};

//uncomment this if you want to see missing translations
// compareObjects(resources.en, resources.ar);

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: "en",
    debug: false,
    //lng: "pl",
    supportedLngs: ["ar", "en"],
    // fallbackLng: "pl",
    // lng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      transKeepBasicHtmlNodesFor: ["br", "strong", "i"],
    },
  });

if (i18n && i18n.services && i18n.services.formatter) {
  i18n.services.formatter.add(
    "arabicToEasternArabic",
    (value, lng, options) => {
      return value.replace(
        options.numbers || options.count || 0,
        convertToEasternArabic(options.numbers || options.count || 0)
      );
    }
  );
}

export default i18n;
